

































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Location } from 'vue-router';
import LineIndicator from '@/components/common/LineIndicator.vue';

import { numberFormat } from '@/util';

@Component({
  components: {
    LineIndicator,
  },
})
export default class StatTile extends Vue {
  @Prop({ required: false, default: false }) readonly to: Location | false;

  @Prop({ required: true }) readonly title: string;

  @Prop({ default: '' }) readonly subtitle: string;

  @Prop({ default: null }) readonly value: number | null;

  @Prop({ required: true }) readonly max: number;

  get numberFormat() {
    return numberFormat;
  }

  get percent() {
    if (this.value === null) {
      return '0%';
    }
    return `${Math.floor((this.value / this.max) * 100)}%`;
  }
}
